export const API_ENDPOINT_HIRER_GRAPH = 'API_ENDPOINT_HIRER_GRAPH';

export const ENVIRONMENT = 'ENVIRONMENT';

export const SSO_REDIRECT_URI = 'SSO_REDIRECT_URI';
export const SSO_SILENT_VERIFICATION_URL = 'SSO_SILENT_VERIFICATION_URL';

export const APP_NAME = 'APP_NAME';
export const APP_BRANCH = 'branch';
export const APP_VERSION = 'version';

export const BRAND = 'BRAND';
export const COUNTRY = 'COUNTRY';
export const LANGUAGE = 'LANGUAGE';
export const SITE = 'SITE';
export const ZONE = 'ZONE';
